import * as React from "react";

export interface SliderProps extends React.HTMLAttributes<HTMLDivElement> {
	value?: number[];
	onValueChange?: (value: number[]) => void;
	min?: number;
	max?: number;
	step?: number;
	disabled?: boolean;
}

export const Slider = React.forwardRef<HTMLDivElement, SliderProps>(
	(
		{
			value = [0],
			onValueChange,
			min = 0,
			max = 100,
			step = 1,
			disabled = false,
			className = "",
			...props
		},
		ref,
	) => {
		return (
			<div ref={ref} className={className} {...props}>
				<input
					type="range"
					min={min}
					max={max}
					step={step}
					value={value[0]}
					disabled={disabled}
					onChange={(e) => onValueChange?.([Number(e.target.value)])}
					className="w-full"
				/>
			</div>
		);
	},
);

Slider.displayName = "Slider";
